import { useContext } from 'react'
import { ImageOrganizeContext } from '../providers/ImageOrganizeProvider'

export default function useImageOrganizeContext() {
  return useContext(ImageOrganizeContext)
}
